export const selectedCloudConfigKey = 'selectedCloudConfiguration';

export const recentlyUpdatedProjectsKey = 'recentProjectsIds';
export const recentProjectIdsLimit = 3;

export const recentlyVisitedProjectIdsKey = 'recentlyVisitedProjectIds';
export const recentlyVisitedProjectIdsLimit = 5;

export const needReviewEnvironmentProjectIdsFilterKey = 'needReviewEnvironmentProjectIdsFilter';
export const needReviewEnvironmentTemplateIdsFilterKey = 'needReviewEnvironmentTemplateIdsFilter';
